<!--金融服务详情-->
<!--wj--->
<template>
    <div class="sfDetail">
        <detail-title></detail-title>
        <img :src="list.trsfPic" :onerror="mylogo" style="padding-top:6rem;width:100%;">
        <div class="offline-detail">
            <p class="offline-title"><strong>{{list.trsfTitle}}</strong></p>
        </div>
        <div class="bbs-line"></div>
        <p class="offline-jj">简介</p>
        <div class="offline-detail">
            <p class="offline-intro" v-html="list.trsfText">{{list.trsfText}}</p>
        </div>
        <span class="Offline-footer">
            <button type="button" class="Offline-btn"><a v-bind:href="list.trsfUrl" style="padding: 3% 35%;">打开链接</a></button>
        </span>
        <share-wechat></share-wechat>
    </div>
</template>
<<script>
import Axios from 'axios';
import { eventBus } from '@/assets/js/eventBus';
import ShareWechat from "@/components/ShareWechat";
import DetailTitle from '@/components/DetailTitle';
export default {
    data(){
        return{
            list:[],
            mylogo:'this.src="' + require("@/assets/image/gg1.jpg") + '"',
            trsfId:'',
        };
    },
    mounted() {
        const that = this;
        var id;
        var locations = location.href;
        if (locations.indexOf("?") != -1) {    //判断是否有参数
          if(locations.indexOf("from") != -1){
                var str = locations.substr(0); //从第一个字符开始 因为第0个是?号 获取所有除问号的所有符串
                var strs = str.split("?");
                id = strs[2];
                var list = id.split("=");
                that.trsfId = list[1];
          }else{
            var str = locations.substr(0); //从第一个字符开始 因为第0个是?号 获取所有除问号的所有符串
            var strs = str.split("?");
            id = strs[1];   //用等号进行分隔 （因为知道只有一个参数 所以直接用等号进分隔 如果有多个参数 要用&号分隔 再用等号进行分隔）
            var list = id.split("=");
            that.trsfId = list[1];
          }
        }
        var param = {
            trsfId:that.trsfId,
        }
        Axios.post(that.$store.state.APIURLS+"Trsf/selectById",param).then(function(res) {
            if(res.data.code ==200){
                res.data.data.trsfPic = res.data.data.trsfPic? res.data.data.trsfPic:'',
                that.list = res.data.data;
                var shareList = {
                    title: res.data.data.trsfTitle,
                    content: res.data.data.trsfText,
                };
                eventBus.$emit("shareList", shareList);
            }
        });
    },
    components:{
        DetailTitle,
        ShareWechat
    },
};
</script>
